import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AboutComponent } from "./components/pages/about/about.component";
import { ServicesComponent } from "./components/pages/services/services.component";
import { ServiceDetailsComponent } from "./components/pages/service-details/service-details.component";
import { ProjectsComponent } from "./components/pages/projects/projects.component";
import { ProjectDetailsComponent } from "./components/pages/project-details/project-details.component";
import { BlogComponent } from "./components/pages/blog/blog.component";
import { BlogDetailsComponent } from "./components/pages/blog-details/blog-details.component";
import { FeaturesComponent } from "./components/pages/features/features.component";
import { TeamComponent } from "./components/pages/team/team.component";
import { PricingComponent } from "./components/pages/pricing/pricing.component";
import { PartnerComponent } from "./components/pages/partner/partner.component";
import { NotFoundComponent } from "./components/pages/not-found/not-found.component";
import { FaqComponent } from "./components/pages/faq/faq.component";
import { ContactComponent } from "./components/pages/contact/contact.component";
import { HomeDemoOneComponent } from "./components/pages/home-demo-one/home-demo-one.component";
import { HomeDemoTwoComponent } from "./components/pages/home-demo-two/home-demo-two.component";
import { HomeDemoThreeComponent } from "./components/pages/home-demo-three/home-demo-three.component";
import { HomeDemoFourComponent } from "./components/pages/home-demo-four/home-demo-four.component";
import { HomeDemoFiveComponent } from "./components/pages/home-demo-five/home-demo-five.component";
import { HomeDemoSixComponent } from "./components/pages/home-demo-six/home-demo-six.component";
import { HomeDemoSevenComponent } from "./components/pages/home-demo-seven/home-demo-seven.component";
import { HomeDemoEightComponent } from "./components/pages/home-demo-eight/home-demo-eight.component";
import { HomeDemoNineComponent } from "./components/pages/home-demo-nine/home-demo-nine.component";
import { AboutStyleTwoComponent } from "./components/pages/about-style-two/about-style-two.component";
import { TeamStyleTwoComponent } from "./components/pages/team-style-two/team-style-two.component";
import { LoginComponent } from "./components/pages/login/login.component";
import { AdministrationComponent } from './components/pages/administration/administration.component';
import { RegisterComponent } from "./components/pages/register/register.component";
import { ServicesStyleTwoComponent } from "./components/pages/services-style-two/services-style-two.component";
import { ServicesStyleThreeComponent } from "./components/pages/services-style-three/services-style-three.component";
import { ProjectsStyleTwoComponent } from "./components/pages/projects-style-two/projects-style-two.component";
import { ProjectsStyleThreeComponent } from "./components/pages/projects-style-three/projects-style-three.component";
import { ProjectsStyleFourComponent } from "./components/pages/projects-style-four/projects-style-four.component";
import { BlogRightSidebarComponent } from "./components/pages/blog-right-sidebar/blog-right-sidebar.component";
import { HomeDemoTenComponent } from "./components/pages/home-demo-ten/home-demo-ten.component";
import { HomeDemoElevenComponent } from "./components/pages/home-demo-eleven/home-demo-eleven.component";
import { HomeDemoTwelveComponent } from "./components/pages/home-demo-twelve/home-demo-twelve.component";
import { TemplatePageComponent } from "./components/pages/template-page/template-page.component";
import { ImageFolderComponent } from "./components/pages/image-folder/image-folder.component";
import { ImageGalleryComponent } from "./components/pages/image-gallery/image-gallery.component";
import { VideoGalleryComponent } from "./components/pages/video-gallery/video-gallery.component";
import { VideoFolderComponent } from "./components/pages/video-folder/video-folder.component";
import { NoticeComponent } from "./components/pages/notice/notice.component";
import { TeachersComponent } from "./components/pages/teachers/teachers.component";
import { ContactUsComponent } from "./components/pages/contact-us/contact-us.component";
import { EmployeComponent } from "./components/pages/employe/employe.component";

const routes: Routes = [
  { path: '', component: HomeDemoOneComponent },
  { path: 'online-admission', component: ContactUsComponent },
  { path: 'অধ্যক্ষের বাণী', component: HomeDemoTwoComponent },
  { path: 'বৈশিষ্ট্য', component: HomeDemoThreeComponent },
  { path: 'প্রতিষ্ঠার পরিকল্পনা', component: HomeDemoFourComponent },
  { path: 'কমপ্লেক্স', component: HomeDemoFiveComponent },
  { path: 'শিক্ষক মন্ডলীর তথ্যাবলী', component: HomeDemoSixComponent },
  { path: 'কর্মকর্তা ও কর্মচারী', component: HomeDemoSevenComponent },
  { path: 'submenu', component: HomeDemoEightComponent },
  { path: 'at-a-glance', component: TemplatePageComponent },
  { path: 'infustructure', component: TemplatePageComponent },
  { path: 'academic-rules', component: TemplatePageComponent },
  { path: 'school-class-routine', component: TemplatePageComponent },
  { path: 'college-class-routine', component: TemplatePageComponent },
  { path: 'lesson-plan', component: TemplatePageComponent },
  { path: 'academic-calendar', component: TemplatePageComponent },
  { path: 'holiday-calender', component: TemplatePageComponent },
  { path: 'course-and-program', component: TemplatePageComponent },
  { path: 'syllabus-and-booklist', component: TemplatePageComponent },
  { path: 'magazine', component: TemplatePageComponent },
  { path: 'rules-and-regulations', component: TemplatePageComponent },
  { path: 'admission-circular', component: TemplatePageComponent },
  { path: 'admission-form', component: TemplatePageComponent },
  { path: 'selected-candidates', component: TemplatePageComponent },
  { path: 'waiting-list', component: TemplatePageComponent },
  { path: 'admission-result', component: TemplatePageComponent },
  { path: 'exam-rules', component: TemplatePageComponent },
  { path: 'faq', component: TemplatePageComponent },
  { path: 'admission-procedure', component: TemplatePageComponent },
  { path: 'payment-process', component: TemplatePageComponent },
  { path: 'download-admit-card', component: TemplatePageComponent },
  { path: 'admission-instruction', component: TemplatePageComponent },
  { path: "student's-login", component: TemplatePageComponent },
  { path: "teacher's-login", component: TemplatePageComponent },
  { path: 'notice', component: NoticeComponent },
  { path: 'teacher-training', component: TemplatePageComponent },
  { path: 'foundation-course', component: TemplatePageComponent },
  { path: 'language-learning-courses', component: TemplatePageComponent },
  { path: 'khatme-bukhari', component: TemplatePageComponent },
  { path: 'social-and-inviting', component: TemplatePageComponent },
  { path: 'activities', component: TemplatePageComponent },
  { path: 'introduction', component: TemplatePageComponent },
  { path: 'physics', component: TemplatePageComponent },
  { path: 'chemistry', component: TemplatePageComponent },
  { path: 'biology', component: TemplatePageComponent },
  { path: 'library-introduction', component: TemplatePageComponent },
  { path: 'catalog', component: TemplatePageComponent },
  { path: 'hefz', component: TemplatePageComponent },
  { path: 'ebtedayee', component: TemplatePageComponent },
  { path: 'dakhil-general-and-science', component: TemplatePageComponent },
  { path: 'alim-general-and-science', component: TemplatePageComponent },
  { path: 'fazil-pass', component: TemplatePageComponent },
  { path: 'fazil-hons', component: TemplatePageComponent },
  { path: 'kamil', component: TemplatePageComponent },
  { path: 'kamil--masters', component: TemplatePageComponent },
  { path: 'department-of-literature-and-culture', component: TemplatePageComponent },
  { path: 'department-of-computer-and-ict', component: TemplatePageComponent },
  { path: 'admission-time', component: TemplatePageComponent },
  { path: 'education-level', component: TemplatePageComponent },
  { path: 'ceremony-garland', component: TemplatePageComponent },
  { path: 'result', component: TemplatePageComponent },
  { path: 'exam-procedure', component: TemplatePageComponent },
  { path: 'list-of-holidays', component: TemplatePageComponent },
  { path: 'notice-of-examination', component: TemplatePageComponent },
  { path: 'our-curriculum', component: TemplatePageComponent },
  { path: 'extra-co-curricular', component: TemplatePageComponent },
  { path: 'admission-exam', component: TemplatePageComponent },
  { path: 'class-wise-fees', component: TemplatePageComponent },
  { path: 'admission-condition', component: TemplatePageComponent },
  { path: 'papers-for-admission', component: TemplatePageComponent },
  { path: 'policy', component: TemplatePageComponent },
  { path: 'others', component: TemplatePageComponent },
  { path: 'administration/teacher-information', component: TemplatePageComponent },
  { path: 'feature', component: TemplatePageComponent },
  { path: 'establishment-plan', component: TemplatePageComponent },
  { path: 'exam-routine', component: TemplatePageComponent },
  { path: "administration/teachers-list-school", component: TemplatePageComponent },
  { path: 'academic-login', component: TemplatePageComponent },
  { path: 'admin-panel', component: TemplatePageComponent },
  { path: 'duty-teacher-information', component: TemplatePageComponent },
  { path: 'online-admission', component: ContactUsComponent },
  { path: 'institute-result', component: TemplatePageComponent },
  { path: 'co-curicular', component: TemplatePageComponent },
  { path: 'admission-prospectus', component: TemplatePageComponent },
  { path: 'establishment-history', component: TemplatePageComponent },
  { path: 'about-trust', component: TemplatePageComponent },
  { path: 'lifetime-donor-body', component: TemplatePageComponent },
  { path: 'mission-and-vision', component: TemplatePageComponent },
  { path: 'academic-team', component: TemplatePageComponent },
  { path: 'exam-time-syllabus', component: TemplatePageComponent },
  { path: 'library-and-repository-of-knowledge', component: TemplatePageComponent },
  { path: 'result-procedure', component: TemplatePageComponent },
  { path: 'scholarship-list', component: TemplatePageComponent },
  { path: 'admission-guideline', component: TemplatePageComponent },
  { path: 'online-apply', component: TemplatePageComponent },
  { path: 'fee-payment-details', component: TemplatePageComponent },
  { path: 'notice-board', component: NoticeComponent },
  { path: 'madrasa-important-notice', component: TemplatePageComponent },
  { path: 'event-seminar', component: TemplatePageComponent },
  { path: 'general-forms', component: TemplatePageComponent },
  { path: 'textbooks-and-educational-materials', component: TemplatePageComponent },
  { path: 'location-map', component: TemplatePageComponent },
  { path: 'namaj-timeline', component: TemplatePageComponent },
  { path: 'recitation-of-the-holy-quran-and-hadith', component: TemplatePageComponent },
  { path: 'ramadan-and-iftar-schedule', component: TemplatePageComponent },
  { path: 'management-portal', component: TemplatePageComponent },
  { path: 'event-and-seminar', component: TemplatePageComponent },
  { path: 'academic-infastructure', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },

  { path: 'hostel-introduction', component: TemplatePageComponent },
  { path: 'halls-of-residence-and-directors', component: TemplatePageComponent },
  { path: 'rules-for-obtaining-accommodation', component: TemplatePageComponent },
  { path: 'accommodation-charges', component: TemplatePageComponent },
  { path: 'residential-policy', component: TemplatePageComponent },
  { path: 'daily-residential-schedule', component: TemplatePageComponent },
  { path: 'publication', component: TemplatePageComponent },
  { path: 'annual-activities', component: TemplatePageComponent },
  { path: 'monthly-publication', component: TemplatePageComponent },
  { path: 'quarterly-millat', component: TemplatePageComponent },
  { path: 'six-month-publication', component: TemplatePageComponent },
  { path: 'academic-calendar', component: TemplatePageComponent },
  { path: 'the-diary', component: TemplatePageComponent },
  { path: 'deyalika', component: TemplatePageComponent },
  { path: "software's-login", component: TemplatePageComponent },
  { path: "admin's-login", component: TemplatePageComponent },
  { path: 'guardians', component: TemplatePageComponent },
  { path: 'student-welfare-department', component: TemplatePageComponent },
  { path: 'mtts-blood-bank', component: TemplatePageComponent },
  { path: 'our-achievement', component: TemplatePageComponent },
  { path: 'class-routine', component: TemplatePageComponent },
  { path: 'administration/teacher-information', component: TeachersComponent },
  { path: 'administration/staff-information', component: EmployeComponent },
  { path: 'governing-body', component: AdministrationComponent },
  { path: 'message-of-chairman', component: AdministrationComponent },
  { path: 'message-of-chief-patron', component: AdministrationComponent },
  { path: 'message-of-vice-chairman', component: AdministrationComponent },
  { path: 'message-of-vice-principal', component: AdministrationComponent },
  { path: 'message-of-principal', component: AdministrationComponent },
  { path: 'secretory-general-message', component: AdministrationComponent },
  { path: 'message-of-senior-vice-president', component: AdministrationComponent },
  { path: 'superintendent-msg', component: AdministrationComponent },
  { path: 'assistant-superintendent-msg', component: AdministrationComponent },
  { path: 'administration/message-of-chairman', component: AdministrationComponent },
  { path: 'administration/message-of-chief-patron', component: AdministrationComponent },
  { path: 'administration/message-of-vice-chairman', component: AdministrationComponent },
  { path: 'administration/message-of-vice-principal', component: AdministrationComponent },
  { path: 'administration/message-of-principal', component: AdministrationComponent },
  { path: 'administration/message-of-secretary-general', component: AdministrationComponent },
  { path: 'administration/message-of-senior-vice-president', component: AdministrationComponent },
  { path: 'administration/message-of-superintendent', component: AdministrationComponent },
  { path: 'administration/message-of-assistant-superintendent', component: AdministrationComponent },
  { path: 'administration', component: AdministrationComponent },
  { path: 'administration/:item', component: AdministrationComponent },




  { path: 'photo-gallery', component: ImageGalleryComponent },
  { path: 'video-gallery', component: VideoGalleryComponent },


  {
    path: "imageFolder",
    children: [
      { path: "", component: ImageFolderComponent },
      { path: ":folderId", component: ImageFolderComponent },
    ],
  },
  {
    path: "videoFolder",
    children: [
      { path: "", component: VideoFolderComponent },
      { path: ":folderId", component: VideoFolderComponent },
    ],
  },



  { path: 'prospectus', component: TemplatePageComponent },
  { path: 'underconstruction', component: TeamStyleTwoComponent },
  { path: 'contact', component: ContactComponent },
  // Here add new pages component

  { path: '**', component: NotFoundComponent }, // This line will remain down from the whole pages component list
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
